import { render, staticRenderFns } from "./EquiposTable.view.vue?vue&type=template&id=359da0b4&scoped=true"
import script from "./EquiposTable.view.vue?vue&type=script&lang=js"
export * from "./EquiposTable.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359da0b4",
  null
  
)

export default component.exports